import { createSafeJotaiSessionStorage } from '@heidi/utils/jotai-storage';
import { getDefaultStore } from 'jotai';
import { atomWithStorage, RESET } from 'jotai/utils';

/**
 * Set by the `/dictate/get-started` entry; while true the Heidi II welcome
 * stands down. Lasts until the tab closes or the user signs out.
 */
export const cameFromDictateDownloadEntryAtom = atomWithStorage<boolean>(
  'heidi-dictate-download-entry',
  false,
  createSafeJotaiSessionStorage<boolean>(),
  { getOnInit: true }
);

/** Clears the live atom and its sessionStorage row, so the next account gets the welcome. */
export function clearDictateDownloadEntry(): void {
  getDefaultStore().set(cameFromDictateDownloadEntryAtom, RESET);
}
